"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1831],{

/***/ 4837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ CustomerSection; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _hooks_useInView__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5467);
/* harmony import */ var _utils_clients__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1358);





var CustomerSection = function(param) {
    var _title = param.title, title = _title === void 0 ? "Our Valued Customers" : _title;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_hooks_useInView__WEBPACK_IMPORTED_MODULE_1__/* .useInView */ .Y)({
        threshold: 0.25
    }), 2), ref1 = ref[0], inView = ref[1];
    // Duplicate for seamless loop
    var marqueeItems = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_utils_clients__WEBPACK_IMPORTED_MODULE_2__/* .namedClients */ .e).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_utils_clients__WEBPACK_IMPORTED_MODULE_2__/* .namedClients */ .e));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        ref: ref1,
        className: "px-4 mt-5 mb-5 text-black w-full flex flex-col items-center transition-all duration-700 ease-out transform ".concat(inView ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "rounded-2xl w-full mt-4",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                    className: "lg:text-4xl text-2xl font-bold text-black text-center lg:mb-6 mb-4",
                    children: title
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute inset-y-0 left-0 w-24 pointer-events-none z-10 bg-gradient-to-r from-white to-transparent"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute inset-y-0 right-0 w-24 pointer-events-none z-10 bg-gradient-to-l from-white to-transparent"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex animate-marquee gap-0",
                            children: [
                                0,
                                1
                            ].map(function(copy) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "flex flex-shrink-0 items-center gap-8 px-4",
                                    children: _utils_clients__WEBPACK_IMPORTED_MODULE_2__/* .namedClients.map */ .e.map(function(client) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            href: client.url !== "#" ? client.url : undefined,
                                            target: client.url !== "#" ? "_blank" : undefined,
                                            rel: "noopener noreferrer",
                                            className: "flex-shrink-0 flex items-center justify-center",
                                            title: client.name,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "h-12 w-28 flex items-center justify-center rounded-lg px-2 ".concat(client.darkBg ? "bg-gray-800" : "bg-gray-50"),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: client.logo,
                                                    alt: client.name,
                                                    className: "max-h-8 max-w-full object-contain"
                                                })
                                            })
                                        }, "".concat(copy, "-").concat(client.name));
                                    })
                                }, copy);
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 3230:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1608);
/* harmony import */ var next_future_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_future_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _hooks_useScreenSize__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5344);


var Navbar = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7804), __webpack_require__.e(7196)]).then(__webpack_require__.bind(__webpack_require__, 7804));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7804)
            ];
        }
    },
    ssr: false
});



function Service2(param) {
    var heading = param.heading, paragraph = param.paragraph, bgPath = param.bgPath, textColor = param.textColor, mainHeading = param.mainHeading, styleClass = param.styleClass, _primaryCta = param.primaryCta, primaryCta = _primaryCta === void 0 ? null : _primaryCta, _heroSvg = param.heroSvg, heroSvg = _heroSvg === void 0 ? null : _heroSvg;
    var size = (0,_hooks_useScreenSize__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)();
    var isSmall = size == "sm" || size == "md";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "h-fit max-h-auto flex items-center pt-12 ".concat(styleClass),
                style: {
                    backgroundImage: isSmall && !heroSvg ? "url('".concat(bgPath, "')") : ""
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "".concat(heroSvg ? "" : "opacity-[0.7] md:opacity-100", " w-[100%] md:w-[65%] h-fit max-h-auto flex flex-col px-6 pb-16 pt-[50px] md:pt-12 ").concat(textColor ? textColor : "text-services-main-txt", " service_txt  "),
                        children: [
                            mainHeading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-2xl font-bold md:text-3xl py-6",
                                children: mainHeading
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                className: "text-3xl font-bold md:text-5xl py-3",
                                children: heading
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xl pt-8 whitespace-pre-line",
                                dangerouslySetInnerHTML: {
                                    __html: paragraph
                                }
                            }),
                            primaryCta && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                href: primaryCta.href,
                                passHref: true,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    className: "mt-8 inline-block self-start bg-[#f1aa4e] text-black font-semibold text-base px-6 py-3 rounded-md hover:bg-[#e09a3e] transition-colors",
                                    children: primaryCta.label
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: heroSvg ? "hidden md:flex items-center justify-center w-[35%] py-16 px-8" : "",
                        children: heroSvg ? heroSvg : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_future_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: bgPath,
                            className: "w-auto h-[0vh] md:min-h-[100vh] mx-auto object-cover",
                            width: "500",
                            height: "500",
                            alt: "how-digitisation-helps-formulation-companies",
                            sizes: "(max-width: 500px) 50vw, (max-width: 1200px) 70vw, 100vw",
                            placeholder: "blur",
                            blurDataURL: bgPath
                        })
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Service2);


/***/ }),

/***/ 5733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ServiceEngagementLinks; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);


function ServiceEngagementLinks() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "bg-[#0d0822] py-14 px-6",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-5xl mx-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-xs font-semibold uppercase tracking-widest text-indigo-400 mb-8",
                    children: "Before you engage"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-1 md:grid-cols-2 gap-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/itmtb-how-we-work",
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "block bg-[#160f2e] border border-white/10 rounded-xl p-7 hover:border-indigo-500/40 transition-colors group",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xs uppercase tracking-widest text-indigo-400 mb-3",
                                        children: "Engagement Model"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-lg font-bold text-white mb-3 group-hover:text-indigo-300 transition-colors",
                                        children: "How we work"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-sm text-slate-300 leading-relaxed",
                                        children: "Discovery sprints, fixed-scope builds, T&M, retainers, and outcome-linked models — with pricing logic and what to expect at each stage."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mt-5 inline-block text-sm font-semibold text-indigo-400",
                                        children: "Read the engagement guide →"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                            href: "/blog/custom-software-development-cost-india",
                            legacyBehavior: true,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                className: "block bg-[#160f2e] border border-white/10 rounded-xl p-7 hover:border-indigo-500/40 transition-colors group",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-xs uppercase tracking-widest text-indigo-400 mb-3",
                                        children: "Cost Guide"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "text-lg font-bold text-white mb-3 group-hover:text-indigo-300 transition-colors",
                                        children: "What custom software costs in India"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-sm text-slate-300 leading-relaxed",
                                        children: "Pricing models, total cost of ownership, QA investment, and support SLA economics — a full breakdown for enterprise buyers evaluating a build."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mt-5 inline-block text-sm font-semibold text-indigo-400",
                                        children: "Read the cost guide →"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 2616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ServiceFAQ; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);


function ServiceFAQ(param) {
    var _items = param.items, items = _items === void 0 ? [] : _items;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), openIndex = ref[0], setOpenIndex = ref[1];
    if (!items.length) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: "px-8 md:px-[60px] py-12 bg-white",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-4xl mx-auto",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                    className: "text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center",
                    children: "Frequently asked questions"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "divide-y divide-gray-200 border-t border-gray-200",
                    children: items.map(function(item, idx) {
                        var isOpen = openIndex === idx;
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "py-5",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                    onClick: function() {
                                        return setOpenIndex(isOpen ? null : idx);
                                    },
                                    className: "w-full flex justify-between items-start gap-4 text-left group",
                                    "aria-expanded": isOpen,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-base md:text-lg font-semibold text-gray-900 group-hover:text-blue-600 transition-colors",
                                            children: item.q
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "flex-shrink-0 mt-0.5 text-gray-500 group-hover:text-blue-600 transition-colors",
                                            children: isOpen ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                className: "w-5 h-5",
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M5 15l7-7 7 7"
                                                })
                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                className: "w-5 h-5",
                                                fill: "none",
                                                stroke: "currentColor",
                                                viewBox: "0 0 24 24",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    strokeWidth: 2,
                                                    d: "M19 9l-7 7-7-7"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "mt-4 ".concat(isOpen ? "block" : "hidden"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-base leading-relaxed",
                                            children: item.a
                                        }),
                                        item.link && item.linkLabel && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                            href: item.link,
                                            className: "mt-3 inline-block text-sm font-semibold text-blue-600 hover:text-blue-800 transition-colors",
                                            children: [
                                                item.linkLabel,
                                                " →"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, idx);
                    })
                })
            ]
        })
    });
};


/***/ }),

/***/ 5467:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ useInView; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);



var useInView = function() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isInView = ref1[0], setIsInView = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var observer = new IntersectionObserver(function(param) {
            var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(param, 1), entry = _param[0];
            if (entry.isIntersecting) {
                setIsInView(true);
                observer.unobserve(entry.target); // remove if you want it to trigger only once
            }
        }, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
            threshold: 0.1
        }, options));
        if (ref.current) observer.observe(ref.current);
        return function() {
            return observer.disconnect();
        };
    }, []);
    return [
        ref,
        isInView
    ];
};


/***/ }),

/***/ 5344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useScreenSize = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(""), screenSize = ref[0], setScreenSize = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var handleResize = function() {
            var screenWidth = window.innerWidth;
            var size = "";
            if (screenWidth < 480) {
                size = "sm";
            } else if (screenWidth >= 440 && screenWidth < 768) {
                size = "md";
            } else if (screenWidth >= 768 && screenWidth < 992) {
                size = "lg";
            } else {
                size = "xl";
            }
            setScreenSize(size);
        };
        handleResize(); // Initial call to set screen size on component mount
        window.addEventListener("resize", handleResize);
        return function() {
            window.removeEventListener("resize", handleResize);
        };
    }, []); // Empty dependency array to run the effect only once on component mount
    return screenSize;
};
/* harmony default export */ __webpack_exports__["Z"] = (useScreenSize);


/***/ }),

/***/ 1180:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "s": function() { return /* binding */ getRandom; }
/* harmony export */ });
var getRandom = function(arr, n) {
    var result = new Array(n), len = arr.length, taken = new Array(len);
    if (n > len) throw new RangeError("getRandom: more elements taken than available");
    while(n--){
        var x = Math.floor(Math.random() * len);
        result[n] = arr[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
};


/***/ }),

/***/ 1358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ namedClients; }
/* harmony export */ });
var namedClients = [
    {
        name: "Wright Research",
        logo: "/companies/wright.webp",
        url: "https://www.wrightresearch.in/"
    },
    {
        name: "Arete Labs",
        logo: "/companies/arete.webp",
        url: "https://www.arete-labs.com/"
    },
    {
        name: "Paterson Securities",
        logo: "/companies/Paterson.webp",
        url: "https://paterson.co.in/"
    },
    {
        name: "The Business Research Company",
        logo: "/companies/tbrc.avif",
        url: "https://www.thebusinessresearchcompany.com"
    },
    {
        name: "The Indian Garage Co.",
        logo: "/companies/tigc.svg",
        url: "https://tigc.in"
    },
    {
        name: "GlobalFair",
        logo: "/companies/globalfair.png",
        url: "https://www.myglobalfair.com"
    },
    {
        name: "Centre for Development of Advanced Computing",
        logo: "/companies/cdac.png",
        url: "https://www.cdac.in"
    },
    {
        name: "Aromathai Spa",
        logo: "/companies/aromathai.svg",
        url: "https://www.aromathai.com"
    },
    {
        name: "Corewellness",
        logo: "/companies/corewellness.png",
        url: "https://corefitplus.com"
    },
    {
        name: "Snuckworks Platforms",
        logo: "/companies/snuckworks.png",
        url: "https://snuckworks.com",
        darkBg: true
    },
    {
        name: "Fonepay",
        logo: "/companies/fonepay.webp",
        url: "#"
    }, 
];


/***/ })

}]);